import { useRecoilValue } from "recoil";
import { contractSidebarState } from "../state/uiState";

export const useEditSidebarWidth = () => {
  const { width } = useRecoilValue(contractSidebarState);
  return width;
};
